import styled from 'styled-components'

export const Section = styled.section`
  width: 100%;
  background: #fff;
  padding-top: 75px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Title = styled.h2`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 36px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: var(--blue6, #21105d);
  margin-bottom: 48px;

  @media (max-width: 600px) {
    font-size: 24px;
    margin-bottom: 30px;
    padding: 0 20px;
  }
`

export const CardsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
  justify-content: center;
  width: 100%;
  max-width: 1300px;
  @media (max-width: 1200px) {
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }
  @media (max-width: 600px) {
    width: 85vw;
  }
`

export const CardSVG = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 0;
  opacity: 1;

  @media (max-width: 600px) {
    top: 50%;
    right: 17px;
    bottom: unset;
    transform: translateY(-50%);
  }

  img {
    display: block;
  }
`

export const Card = styled.div`
  position: relative;
  width: 391px;
  height: 242px;
  border-radius: 30px;
  background: var(--grey5, #f7f9fc);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  @media (max-width: 600px) {
    width: 100%;
    height: 121px;
    border-radius: 30px;
  }

  &.alunos ${CardSVG} img {
    @media (max-width: 600px) {
      width: 72px;
      height: 52px;
    }
  }

  &.instituicoes ${CardSVG} img {
    @media (max-width: 600px) {
      width: 72px;
      height: 40px;
    }
  }

  &.conteudos ${CardSVG} img {
    @media (max-width: 600px) {
      width: 75px;
      height: 64px;
    }
  }
`

export const CardText1 = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 2%;
  text-align: center;
  color: var(--blue6, #21105d);
  margin-bottom: 0.5em;
  z-index: 1;

  @media (max-width: 600px) {
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 2px;
  }
`

export const CardText2 = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 46px;
  line-height: 100%;
  text-align: center;
  color: var(--blue6, #21105d);
  z-index: 1;

  @media (max-width: 600px) {
    font-size: 28px;
  }

  span {
    font-size: 46px;
    font-weight: 700;
    margin-right: 4px;

    @media (max-width: 600px) {
      font-size: 16px;
    }
  }
`

export const CardText3 = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 2%;
  text-align: center;
  color: var(--blue6, #21105d);
  margin-top: 0.5em;
  z-index: 1;

  @media (max-width: 600px) {
    font-size: 12px;
    line-height: 16px;
    margin-top: 2px;
  }
`
